import { render, staticRenderFns } from "./commercialListItemOne.vue?vue&type=template&id=b18bb31a&scoped=true"
import script from "./commercialListItemOne.vue?vue&type=script&lang=js"
export * from "./commercialListItemOne.vue?vue&type=script&lang=js"
import style0 from "./commercialListItemOne.vue?vue&type=style&index=0&id=b18bb31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18bb31a",
  null
  
)

export default component.exports